const React = require('react')
const { useNetworkConfig } = require('@contexts')

const ColorIcon = props => {
    const { network } = useNetworkConfig()

    return (
        <>
            <svg width='0' height='0'>
                <defs>
                    <linearGradient id='gradient' x1='0%' y1='0%' x2='100%' y2='0%'>
                        <stop offset={network.data.color.fromPosition} stopColor={network.data.color.from} />
                        <stop offset={network.data.color.toPosition} stopColor={network.data.color.to} />
                    </linearGradient>
                </defs>
            </svg>
            {props.icon}
        </>
    )
}

module.exports = { ColorIcon }
